import Ruler from 'components/ruler/Ruler';
import React from 'react';
import styles from './ErrorBoundary.module.scss';

type ErrorBoundaryProps = {
  className?: string;
  debug: React.ReactNode;
};

const ErrorBoundary: React.FC<ErrorBoundaryProps> = ({ className = '', debug }) => {
  const baseCls = `${styles.ErrorBoundaryContainer} ${className}`;
  return (
    <div className={baseCls}>
      <h1>Something broke...</h1>
      <Ruler marginStyle="STEEL" />
      {debug}
    </div>
  );
};

export default ErrorBoundary;
